'use strict'

export const getShuffledArr = arr => {
   // https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
   const newArr = arr.slice()
   for (let i = newArr.length - 1; i > 0; i--) {
      const rand = Math.floor(Math.random() * (i + 1))
      ;[newArr[i], newArr[rand]] = [newArr[rand], newArr[i]]
   }
   return newArr
}

export const shuffleArray = array => {
   for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1))
      var temp = array[i]
      array[i] = array[j]
      array[j] = temp
   }
   return array
}

export const getByPropValue = (items, property, propertyValue) => {
   return items.find(item => item && item[property] === propertyValue)
}

export const validateEmail = function(email) {
   if (!email) {
      return
   }

   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const validatePassword = function(password) {
   if (!password || password.length < 6) {
      return
   }

   return true
}

export const upperFirstLetter = str => str.charAt(0).toUpperCase() + str.substring(1)

export const makePascalCase = str => {
   return str
      .replace(/[\W_]/g, ' ') //convert all hyphens to spaces
      .toLowerCase()
      .split(' ')
      .map(upperFirstLetter)
      .join('')
}

export const makeCamelCase = str => {
   const pascalString = makePascalCase(str)
   return pascalString.charAt(0).toLowerCase() + pascalString.substr(1)
}

export const getRandomId = ({ length = 22 } = {}) => {
   // https://stackoverflow.com/a/1349426/1971662
   var result = ''
   var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
   var charactersLength = characters.length
   for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
   }
   return result

   // Alternative approach
   // https://gist.github.com/gordonbrander/2230317
   // return (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36)
}

export const createImagePath = ({ src, maxWidth }) => {
   if (!src) return
   let queryString = `?auto=format,compress,enhance`
   if (maxWidth) {
      queryString += `&w=${maxWidth}`
   }

   return 'https://remotefit.imgix.net/' + src + queryString
}

export const createImageSrcSet = ({ src, maxWidth }) => {
   const imagePath = createImagePath({ src, maxWidth })
   return `
      ${imagePath} 1x,
      ${imagePath}&dpr=2 2x,
      ${imagePath}&dpr=3 3x,
      ${imagePath}&dpr=4 4x
   `
}

export const isEven = number => number % 2 === 0
